(function() {
    'use strict';

    angular.module('tags').controller('TagCreateController', TagCreateController);

    TagCreateController.$inject = ['$state', 'tagsDataSrvc', 'notificationSrvc', 'tagsMessagesConst', 'errorNotificationSrvc'];

    function TagCreateController($state, tagsDataSrvc, notificationSrvc, tagsMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
        };

        self.tagData = {
            name: '',
        };

        self.createTag = createTag;
        self.cleanErrors = cleanErrors;

        function createTag() {
            tagsDataSrvc.create(
                self.tagData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", tagsMessagesConst.add);
                    $state.go('layout.tags.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
